@file:OptIn(ExperimentalResourceApi::class)

package ui.translation

import androidx.compose.runtime.*
import androidx.compose.ui.text.input.*
import common.frontend.api.*
import org.jetbrains.compose.resources.*
import provider.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.*
import tools.*
import ui.*


interface TranslationListingScope {

    val vmGlobal: GlobalVM
    val vm: TranslationListingVM
    val action: (TranslationListingVM.Action) -> Unit
    val nav: Navigation
    val login: Io.User

    companion object {


        @Composable
        fun rememberScope(): TranslationListingScope {
            val account = LocalAccountProvider.current
            val nav = LocalNavigation.current
            val vm = nav.viewModel(TranslationListingVM::class)
            val vmGlobal = globalViewModel(GlobalVM::class)
            val action = TranslationListingVM.Action.rememberAction(vm)

            return remember {
                object : TranslationListingScope {
                    override val vmGlobal: GlobalVM
                        get() = vmGlobal
                    override val vm: TranslationListingVM
                        get() = vm
                    override val action: (TranslationListingVM.Action) -> Unit
                        get() = action
                    override val nav: Navigation
                        get() = nav
                    override val login: Io.User
                        get() = account.current!!

                }.also {
                    vm.init(it)
                }
            }
        }
    }

    class Wrapper(
        listing: Io.ListingTranslation,
        private val changedInternal: MutableState<Boolean> = mutableStateOf(false),
    ) : EFieldList<Io.ListingTranslation.Item, Wrapper.Item>(
        items = listing.items,
        onBindEntry = {
            Item(it) {
                changedInternal.value = this.state.any { it.changed }
            }
        }
    ) {
        val changed by changedInternal

        val headers: List<String> = listing.items.firstOrNull()
            ?.variants
            ?.entries
            ?.sortedWith(compareBy({ it.key != "en" }, { it.key }))
            ?.map { it.key }
            ?: listOf()

        class Item(
            override val data: Io.ListingTranslation.Item,
            override val key: String = data.name,
            private val onChange: () -> Unit = {},
        ) : Entry<Io.ListingTranslation.Item> {

            var allTranslated by mutableStateOf(data.variants.values.all { it.translated })
                private set

            val allValues get() = data.variants.values.map { it.value }

            var changed by mutableStateOf(false)
                private set

            val variants = WrapperVariants(data)

            fun setNewValues(newData: Io.ListingTranslation.Item) {
                allTranslated = true
                changed = true
                variants.state.forEach {
                    val newVal = newData.variants[it.data.lang]!!.value
                    it.value.set(TextFieldValue(newVal))
                    it.data.change = true
                }
                onChange()
            }
        }
    }

    class WrapperVariants(listing: Io.ListingTranslation.Item) : EFieldList<Io.ListingTranslation.Entry, WrapperVariants.Item>(
        items = listing.variants
            .entries
            .sortedWith(compareBy({ it.key != "en" }, { it.key }))
            .map { it.value }
            .toMutableList(),
        onBindEntry = {
            Item(it)
        }
    ) {
        class Item(
            override val data: Io.ListingTranslation.Entry,
            override val key: String = data.id.toString(),
        ) : Entry<Io.ListingTranslation.Entry> {

            val value: EFieldTextString = EFieldTextString(property = data::value)

        }
    }
}
